import React, { useMemo, useState, useEffect } from "react";
import MaterialReactTable from "material-react-table";
import { Box, CircularProgress } from "@mui/material";
import axios from "axios";
import { useParams } from "react-router-dom";

const IndicadorEvaluadorAyB = () => {
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const grupos = ["A1", "A2", "A3", "A4", "A5", "A6", "A7", "A8", "A9", "A10"];
  const estado = ["DISPONIBLE", "NO DISPONIBLE"];

  const columns = useMemo(
    () => [
      { accessorKey: "id", header: "Id" },
      {
        accessorKey: "grupo",
        header: "Grupo",
        filterVariant: "multi-select",
        filterSelectOptions: grupos,
      },
      { accessorKey: "nombreIndicador", header: "Nombre del Indicador" },
      { accessorKey: "codigo", header: "Código Único" },
      { accessorKey: "nivelDesagregacion", header: "Nivel Desagregación" },
      { accessorKey: "aplicabilidad", header: "Aplicabilidad" },
      {
        accessorKey: "estadoInformacion",
        header: "Estado Información",
        filterVariant: "multi-select",
        filterSelectOptions: estado,
      },
      { accessorKey: "unidadMedicion", header: "Unidad de Medición" },
      { accessorKey: "numerador", header: "Numerador" },
      { accessorKey: "denominador", header: "Denominador" },
      { accessorKey: "resultado", header: "Resultado" },
      { accessorKey: "mesCorte", header: "Mes Corte" },
      { accessorKey: "institucionId", header: "Institución" },
      { accessorKey: "sedeId", header: "Sede" },
      {
        accessorKey: "trimestre",
        header: "Año",
        filterVariant: "range",
        filterFn: "betweenInclusive",
      },
      { accessorKey: "observaciones", header: "Observaciones" },
    ],
    [],
  );

  useEffect(() => {
    setLoading(true);

    axios({
      method: "get",
      url: `https://suadesarrollo.azurewebsites.net/api/QIndicadorAyBInstitucionId?InstitucionId=${id}`,
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
    })
      .then((res) => setData(res.data))
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, [id]);

  return (
    <Box sx={{ mt: 2 }}>
      <MaterialReactTable
        columns={columns}
        data={data}
        enableColumnOrdering
        enableColumnFilters
        enablePagination
        enableMultiRowSelection
        state={{ isLoading: loading }}
        muiTableBodyCellProps={{
          sx: { fontSize: "0.85rem" },
        }}
      />
    </Box>
  );
};

export default IndicadorEvaluadorAyB;
